module.exports = __webpack_public_path__ + "static/media/XLS_import_template.1ab37dca.xlsx";